import { TabNav, type TabItem } from '@g17eco/ui-modern/components/ui/tab-nav';

interface UnitToggleProps {
  showInTonnes: boolean;
  onChange: (showInTonnes: boolean) => void;
  className?: string;
}

type UnitKey = 't' | 'kg';

const UNIT_TABS: TabItem<UnitKey>[] = [
  { key: 't', label: 'tonnes' },
  { key: 'kg', label: 'kg' },
];

export const UnitToggle = ({ showInTonnes, onChange, className }: UnitToggleProps) => (
  <TabNav<UnitKey>
    variant='toggle'
    size='xs'
    tabs={UNIT_TABS}
    activeTab={showInTonnes ? 't' : 'kg'}
    onChange={(key) => onChange(key === 't')}
    className={className}
  />
);
